<template>
  <div class="animated fadeIn">
    <b-alert :show="errors.any()" variant="danger" class="px-4">
      <ul class="m-0 px-1">
        <li v-for="err in errors.all()" :key="err">{{err}}</li>
      </ul>
    </b-alert>
    <div v-if="initializing" class="text-center">
      <font-awesome-icon spin icon="circle-notch" class="text-moremuted display-2"/>
    </div>
    <b-card>
      <b-row>
        <b-col md="7">
          <b-form-group>
            <b-input-group :prepend="$t('users.Username')">
              <b-form-input
              readonly
              v-model="model.username"
              :name="$t('users.Username')"
              v-validate="'required'"/>
            </b-input-group>
          </b-form-group>

          <b-form-group> 
            <b-input-group :prepend="$t('users.FirstName')">
              <b-form-input
                readonly    
                v-model="model.info.firstName"
                dir="auto"
                :name="$t('users.FirstName')">
              </b-form-input>
            </b-input-group>
          </b-form-group>

          <b-form-group>
            <b-input-group :prepend="$t('users.LastName')">
              <b-form-input
                readonly
                v-model="model.info.lastName"
                dir="auto"
                :name="$t('users.LastName')">
              </b-form-input>
            </b-input-group>
          </b-form-group>

          <b-form-group>
            <b-input-group :prepend="$t('account.NationalId')">
              <b-form-input
              readonly
              v-model="model.info.nationalId"
              :name="$t('account.NationalId')"
              v-validate="'required'"/> 
            </b-input-group>
          </b-form-group>

          <b-form-group>
            <b-input-group :prepend="$t('shared.Email')">
              <b-form-input
              readonly
              v-model="model.info.email"
              dir="ltr"
              :name="$t('shared.Email')"
              v-validate="'required|email'"/>
            </b-input-group>
          </b-form-group>

          <b-form-group>
            <b-input-group>
              <b-input-group-prepend is-text>
                {{$t('shared.Mobile')}}
              </b-input-group-prepend>
                <b-form-input
                readonly
                v-model="model.info.mobile"
                :name="$t('shared.Mobile')"
                placeholder= "912xxxxxxx"
                v-validate="(this.$config.auth.mobileRequired) ? 'required|digits:10' : 'digits:10'"/>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="5">
          <b-form-group>
            <uploader
              :label="$t('shared.Image')"
              :name="$t('shared.Image')"/>
          </b-form-group>
        </b-col>
      </b-row>
      <div slot="footer">
        <b-button :disabled="progressing" @click.prevent="submit" variant="success">
          {{$t('shared.Save')}}
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import EditForm from './EditForm'

export default {
  name: 'profile',
  mixins: [EditForm],
  computed: {
    userIsRoot () {
      return this.model.user.userName == this.$config.rootUserName
    }
  },
  mounted () {
   this.getModel()
    .then(() => {
      this.initializing = false
    })
    .catch(err => {
      this.goto(`/dashboard`)
    })
  },
  methods: {
    getModel () {
      return this.$api.profileUser.getprofile()
      .then(res => {
        this.model = res
      })
    },
    //edit not ready 
    // submit () {
    //   this.preSubmit().then(proceed => {
    //     if (proceed) {
    //       return this.$api.profileUser.setProfile(this.model, true)
    //       .then(() => {
    //         return this.success('users.UserUpdated')
    //       }).catch(this.fail)
    //     }
    //   })
    // }
  }
}
</script>
